import * as Immutable from "immutable";
import { getResource } from "selectors/resources";

// Add feature flags to every action so we can access them in all reducers
const featureFlags = store => next => (action) => {
  const state = store.getState();

  /** @type Client */
  const client = getResource(state, "client");

  return next({
    ...action,
    featureFlags: (state && client) ? client.features : Immutable.Map()
  });
};

export default featureFlags;
